// newBankBudgeting.jsx
import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { MultiSelect } from "react-multi-select-component";
import { Table, Row, Col, Button, Form } from "react-bootstrap";
import "../../../../assets/css/style.css";
import "jspdf-autotable";
import DatePicker from "react-datepicker";
import BASE_URL from "../../../../assets/global/url";
import AccountsModal from "./Modal/accountsModal";
import NumberInDecimals from "../../../../components/inputs/NumberFormatted";
import useCutoffData from "../../../../hooks/useCutoffData";
import { PDFDownloadLink } from "@react-pdf/renderer";
import BankBudgetingPDF from "./component/BankBudgetingPDF";
const NewBankBudgeting = ({ authrztn }) => {
  const { cutoffData } = useCutoffData();
  // console.log(cutoffData);

  const [showAccountModal, setShowAccountModal] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  //   const [selectedAccounts, setSelectedAccounts] = useState([
  //   {
  //     id: "initial",
  //     account_name: "",
  //     amount: "",
  //     currency_name: "",
  //     disbursementSumPayables: 0,
  //     allocated_payables: 0,
  //     allocated_receivables: 0,
  //   },
  // ]);
  const getTheLatestCutoff = () => {
    if (!cutoffData?.length) return;

    const latestCutoff = cutoffData.reduce((latest, cutoff) => {
      return new Date(cutoff.to) > new Date(latest.to) ? cutoff : latest;
    });
    getJournals(latestCutoff.to);

    setSelectedCutoff({
      cutoff_id: latestCutoff.id,
      cutoff_name: latestCutoff.name,
      cutoff_from: latestCutoff.from,
      cutoff_to: latestCutoff.to,
      currency_rates: latestCutoff.cutoffcurrencyrates || [],
    });
  };

  useEffect(() => {
    getTheLatestCutoff();
  }, [cutoffData]);

  const [selectedCutoff, setSelectedCutoff] = useState({
    cutoff_id: "",
    cutoff_name: "",
    cutoff_from: "",
    cutoff_to: "",
    currency_rates: [],
  });
  const [getJournal, setGetJournal] = useState({
    receivables: 0,
    payables: 0,
  });
  // console.log(`selectedAccounts`, selectedAccounts);

  // console.log(cutoffData);
  const handleChangeCutoff = (e) => {
    const selectedId = e.target.value;

    const selected = cutoffData.find((cutoff) => cutoff.id === selectedId);

    getJournals(selected.to);
    if (selected) {
      setSelectedCutoff({
        cutoff_id: selected.id,
        cutoff_name: selected.name,
        cutoff_from: selected.from,
        cutoff_to: selected.to,
        currency_rates: selected.cutoffcurrencyrates,
      });
    }
  };

  const getJournals = (endDate) => {
    axios
      .get(`${BASE_URL}/bankBudgeting/getJournal`, {
        params: { endDate: endDate },
      })
      .then((res) => {
        const receivable = res.data.receivable_value;
        const payable = res.data.payable_value;

        setGetJournal({
          receivables: receivable,
          payables: payable,
        });
      });
  };

  const handleAllocatedPayablesChange = (id, value) => {
    const numValue = Number(value);

    setSelectedAccounts((prev) => {
      // Sum of all OTHER accounts' allocated_receivables (excluding current)
      const otherAccountsTotal = prev
        .filter((account) => account.id !== id)
        .reduce((sum, account) => sum + account.allocated_payables, 0);

      // How much is still available for this account
      const remaining = getJournal.payables - otherAccountsTotal;

      // Cap the value so total never exceeds getJournal.payables
      const capped = Math.min(numValue, Math.max(0, remaining));

      return prev.map((account) =>
        account.id === id
          ? { ...account, allocated_payables: capped }
          : account,
      );
    });
  };

  // const handleAllocatedPayablesChange = (id, value) => {
  //   setSelectedAccounts((prev) =>
  //     prev.map((account) =>
  //       account.id === id
  //         ? { ...account, allocated_payables: Number(value) }
  //         : account,
  //     ),
  //   );
  // };

  // const handleAllocatedReceivablesChange = (id, value) => {
  //   setSelectedAccounts((prev) =>
  //     prev.map((account) =>
  //       account.id === id
  //         ? { ...account, allocated_receivables: Number(value) }
  //         : account,
  //     ),
  //   );
  // };

  const handleAllocatedReceivablesChange = (id, value) => {
    const numValue = Number(value);

    setSelectedAccounts((prev) => {
      // Sum of all OTHER accounts' allocated_receivables (excluding current)
      const otherAccountsTotal = prev
        .filter((account) => account.id !== id)
        .reduce((sum, account) => sum + account.allocated_receivables, 0);

      // How much is still available for this account
      const remaining = getJournal.receivables - otherAccountsTotal;

      // Cap the value so total never exceeds getJournal.receivables
      const capped = Math.min(numValue, Math.max(0, remaining));

      return prev.map((account) =>
        account.id === id
          ? { ...account, allocated_receivables: capped }
          : account,
      );
    });
  };

  const calculateAvailableFunds = (account) => {
    const account_currencyName = account.currency_name;

    const currencyData = selectedCutoff.currency_rates.find(
      (data) => data.currency.currency_name === account_currencyName,
    );

    const currencyRate = Number(currencyData?.currency_rate) || 1;

    const balance = Number(account.amount) || 0;

    const disbursement = Number(account.disbursementSumPayables) || 0;

    const payablesPHP = Number(account.allocated_payables) || 0;

    const receivablesPHP = Number(account.allocated_receivables) || 0;

    const payables =
      account_currencyName === "PHP" ? payablesPHP : payablesPHP / currencyRate;

    const receivables =
      account_currencyName === "PHP"
        ? receivablesPHP
        : receivablesPHP / currencyRate;

    // Available Funds
    return balance - disbursement - payables + receivables;
  };

  const handleExportCSV = () => {
    const formatCurrency = (value, currency = "PHP") => {
      const amount = Number(value) || 0;

      const symbol =
        currency === "USD" ? "$" : currency === "PHP" ? "₱" : currency;

      return `${symbol}${amount.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    };

    const escapeCSV = (value) => {
      if (value === null || value === undefined) {
        return "";
      }

      const stringValue = String(value);

      if (
        stringValue.includes(",") ||
        stringValue.includes('"') ||
        stringValue.includes("\n")
      ) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }

      return stringValue;
    };

    const calculateAvailableFundsForExport = (account) => {
      const currencyName = account.currency_name;

      const currencyData = selectedCutoff.currency_rates?.find(
        (data) => data.currency?.currency_name === currencyName,
      );

      const currencyRate = Number(currencyData?.currency_rate) || 1;

      const balance = Number(account.amount) || 0;

      const disbursement = Number(account.disbursementSumPayables) || 0;

      const payablesPHP = Number(account.allocated_payables) || 0;

      const receivablesPHP = Number(account.allocated_receivables) || 0;

      const payables =
        currencyName === "PHP" ? payablesPHP : payablesPHP / currencyRate;

      const receivables =
        currencyName === "PHP" ? receivablesPHP : receivablesPHP / currencyRate;

      return balance - disbursement - payables + receivables;
    };

    // --------------------------------
    // ACCOUNT TABLE
    // --------------------------------

    const accountRows = selectedAccounts.map((account) => {
      const currency = account.currency_name || "PHP";

      const availableFunds = calculateAvailableFundsForExport(account);

      return [
        account.account_name,

        currency,

        formatCurrency(account.amount, currency),

        formatCurrency(account.disbursementSumPayables, currency),

        formatCurrency(account.allocated_payables, "PHP"),

        formatCurrency(account.allocated_receivables, "PHP"),

        formatCurrency(availableFunds, currency),
      ];
    });

    // --------------------------------
    // CSV CONTENT
    // --------------------------------

    const csvRows = [
      // HEADER
      ["BANK BUDGETING"],
      ["Fund Forecasting"],
      [],

      // ACCOUNTING PERIOD
      ["ACCOUNTING PERIOD"],
      ["Cutoff", selectedCutoff?.cutoff_name || ""],
      ["Until", selectedCutoff.cutoff_to || ""],
      [],

      // CURRENCY RATES
      ["CURRENCY RATES"],

      ...(selectedCutoff.currency_rates || []).map((rate) => [
        rate.currency?.currency_name || "",
        formatCurrency(rate.currency_rate, "PHP"),
      ]),

      [],

      // SUMMARY
      ["SUMMARY"],

      [
        "Receivable Collection",
        `${formatCurrency(remainingReceivables, "PHP")} of ${formatCurrency(
          getJournal.receivables,
          "PHP",
        )}`,
      ],

      [
        "Payables",
        `${formatCurrency(remainingPayables, "PHP")} of ${formatCurrency(
          getJournal.payables,
          "PHP",
        )}`,
      ],

      [],

      // ACCOUNT DETAILS
      ["ACCOUNT DETAILS"],

      [
        "Account Name",
        "Currency",
        "Current Balance",
        "Disbursement",
        "Allocate Payables",
        "Allocate Receivables",
        "Available Funds",
      ],

      ...accountRows,
    ];

    const csvContent = csvRows
      .map((row) => row.map(escapeCSV).join(","))
      .join("\n");

    // UTF-8 BOM
    // Helps Excel properly recognize ₱
    const BOM = "\uFEFF";

    const blob = new Blob([BOM + csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.download = `Bank-Budgeting-${selectedCutoff.cutoff_to}.csv`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  // sum constants
  //Receivables
  const totalAllocatedReceivables = selectedAccounts.reduce(
    (sum, acc) => sum + acc.allocated_receivables,
    0,
  );
  const remainingReceivables =
    getJournal.receivables - totalAllocatedReceivables;

  // PAyables
  const totalAllocatedPayables = selectedAccounts.reduce(
    (sum, acc) => sum + acc.allocated_payables,
    0,
  );
  const remainingPayables = getJournal.payables - totalAllocatedPayables;

  return (
    <div className="p-4 bank-budget-page" style={{ minHeight: "100vh" }}>
      {/* Header */}
      <div className="d-flex flex-row justify-content-between align-items-start mb-4">
        <div>
          <h4
            className="fw-bold text-uppercase mb-0 bank-budget-title"
            style={{ letterSpacing: "0.05em" }}>
            Bank Budgeting
          </h4>
          <span
            className="text-primary fw-semibold"
            style={{ fontSize: "0.85rem" }}>
            Fund Forecasting
          </span>
        </div>
        {authrztn?.includes("BankBudgeting-IE") && (
          <div className="dropdown">
            <button
              className="btn btn-outline-danger dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ borderRadius: "8px", fontWeight: 500 }}>
              Export Options
            </button>
            <ul className="dropdown-menu dropdown-menu-end shadow border-0">
              <li>
                <button
                  className="dropdown-item py-2"
                  onClick={handleExportCSV}>
                  📄 CSV Format
                </button>
              </li>

              <li>
                <PDFDownloadLink
                  document={
                    <BankBudgetingPDF
                      selectedCutoff={selectedCutoff}
                      selectedAccounts={selectedAccounts}
                      getJournal={getJournal}
                      totalAllocatedReceivables={totalAllocatedReceivables}
                      totalAllocatedPayables={totalAllocatedPayables}
                    />
                  }
                  fileName={`Bank-Budgeting-${selectedCutoff.cutoff_to}.pdf`}
                  className="dropdown-item py-2 text-decoration-none">
                  {({ loading }) =>
                    loading ? "⏳ Generating PDF..." : "📑 PDF Format"
                  }
                </PDFDownloadLink>
              </li>
            </ul>
          </div>
        )}
      </div>

      {/* Modal */}
      <AccountsModal
        show={showAccountModal}
        onClose={() => setShowAccountModal(false)}
        // onSubmit={handleAccountSubmit}
        selectedAccounts={selectedAccounts}
        setSelectedAccounts={setSelectedAccounts}
        cutoff_TO={selectedCutoff.cutoff_to}
      />

      {/* Accounting Period Card */}
      <div
        className="card border-0 shadow-sm mb-4"
        style={{ borderRadius: "12px" }}>
        <div className="card-body p-4">
          <h6
            className="fw-semibold text-secondary text-uppercase mb-3"
            style={{ fontSize: "0.75rem", letterSpacing: "0.1em" }}>
            Accounting Period
          </h6>
          <Row className="g-3 align-items-end">
            <Col sm={4}>
              <label
                htmlFor="cutoff"
                className="form-label small fw-semibold text-muted mb-1">
                Cutoff
              </label>
              <Form.Select
                // options={cutoffData.map((cutoff) => ({
                //   label: cutoff.name,
                //   value: cutoff.id,
                // }))}
                // labelledBy="Select"
                value={selectedCutoff.cutoff_id}
                onChange={handleChangeCutoff}
                className="w-100"
                disabled
                // hasSelectAll={false}
              >
                <option disabled value="">
                  Select Cutoff ...
                </option>
                {cutoffData.map((data, i) => (
                  <option key={i} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            {/* <Col sm={3}>
              <label className="form-label small fw-semibold text-muted mb-1">
                From
              </label>
              <DatePicker
                dateFormat="MMM/dd/yyyy"
                className="form-control"
                readOnly
                value={selectedCutoff.cutoff_from}
                placeholderText="Select date"
              />
            </Col> */}
            <Col sm={3}>
              <label className="form-label small fw-semibold text-muted mb-1">
                Until
              </label>
              <DatePicker
                dateFormat="MMM/dd/yyyy"
                className="form-control"
                readOnly
                value={selectedCutoff.cutoff_to}
                placeholderText="Select date"
              />
            </Col>
          </Row>
          {selectedCutoff.cutoff_id !== "" && (
            <Row className="mt-3">
              <Col>
                <div className="border rounded-3 bg-light px-3 py-2">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <span
                      className="text-secondary fw-semibold"
                      style={{ fontSize: "0.75rem" }}>
                      CURRENCY RATES
                    </span>
                  </div>

                  <div className="d-flex flex-wrap gap-2">
                    {selectedCutoff.currency_rates.map((data, index) => {
                      const currency_name = data.currency.currency_name;
                      const currency_rate = data.currency_rate;

                      return (
                        <div
                          key={index}
                          className="d-flex align-items-center gap-2 bg-white border rounded-3 px-3 py-2"
                          style={{
                            minWidth: "120px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                          }}>
                          <span
                            className="fw-semibold text-dark"
                            style={{ fontSize: "0.85rem" }}>
                            {currency_name}
                          </span>

                          <span className="text-muted">=</span>

                          <span
                            className="fw-bold text-primary"
                            style={{ fontSize: "0.9rem" }}>
                            ₱
                            {Number(currency_rate).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>

      {/* Summary Badges + Add Account */}
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
        <div className="d-flex flex-wrap gap-3">
          <div
            className="d-flex align-items-center gap-2 px-3 py-2 bg-white rounded-pill shadow-sm border"
            title="Sales Management + Sales Collection Cheques">
            <span
              className="rounded-circle d-inline-block"
              style={{ width: 8, height: 8, backgroundColor: "#0d6efd" }}
            />
            <span className="text-muted small">Receivable Collection:</span>
            <span className="fw-semibold small">
              {remainingReceivables.toLocaleString("en-PH", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
                style: "currency",
                currency: "PHP",
              })}
              <span className="text-muted small"> of </span>
              {getJournal.receivables.toLocaleString("en-PH", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
                style: "currency",
                currency: "PHP",
              })}
            </span>
          </div>
          <div
            className="d-flex align-items-center gap-2 px-3 py-2 bg-white rounded-pill shadow-sm border"
            title="Purchase Management + Created Expenses">
            <span
              className="rounded-circle d-inline-block"
              style={{ width: 8, height: 8, backgroundColor: "#dc3545" }}
            />
            <span className="text-muted small">Payables:</span>
            <span className="fw-semibold small">
              {" "}
              {remainingPayables.toLocaleString("en-PH", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
                style: "currency",
                currency: "PHP",
              })}
              <span className="text-muted small"> of </span>
              {getJournal.payables.toLocaleString("en-PH", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
                style: "currency",
                currency: "PHP",
              })}
            </span>
          </div>
        </div>
        {selectedCutoff.cutoff_id !== "" &&
          authrztn?.includes("BankBudgeting-Add") && (
            <Button
              variant="primary"
              className="shadow-sm fw-semibold"
              style={{ borderRadius: "8px", padding: "8px 18px" }}
              type="button"
              onClick={() => setShowAccountModal(true)}>
              + Add Account
            </Button>
          )}
      </div>

      {/* Table Card */}
      <div
        className="card border-0 shadow-sm"
        style={{ borderRadius: "12px", overflow: "hidden" }}>
        <Table hover responsive className="mb-0 align-middle">
          <thead>
            <tr className="bank-budget-thead">
              <th
                className="px-4 py-3 fw-semibold text-uppercase text-secondary"
                style={{ fontSize: "0.75rem", letterSpacing: "0.07em" }}>
                Account Name
              </th>
              <th
                className="py-3 fw-semibold text-uppercase text-secondary"
                style={{ fontSize: "0.75rem", letterSpacing: "0.07em" }}>
                Current Balance
              </th>
              <th
                className="py-3 fw-semibold text-uppercase text-secondary"
                style={{ fontSize: "0.75rem", letterSpacing: "0.07em" }}>
                Disbursement
              </th>
              <th
                className="py-3 fw-semibold text-uppercase text-secondary"
                style={{ fontSize: "0.75rem", letterSpacing: "0.07em" }}>
                Allocate Payables
              </th>
              <th
                className="py-3 fw-semibold text-uppercase text-secondary"
                style={{ fontSize: "0.75rem", letterSpacing: "0.07em" }}>
                Allocate Receivables
              </th>
              <th
                className="py-3 fw-semibold text-uppercase text-secondary"
                style={{ fontSize: "0.75rem", letterSpacing: "0.07em" }}>
                Available Funds
              </th>
            </tr>
          </thead>
          <tbody>
            {/* {[...Array(1)].map((_, i) => ( */}
            {selectedAccounts
              // .filter((data) => data.id !== "initial")
              .map((data, i) => (
                <tr key={i} className="bank-budget-row">
                  <td className="px-4 py-3">
                    <span className="fw-semibold text-dark">
                      {data.account_name}
                    </span>
                  </td>
                  <td className="py-3">
                    <span className="badge bg-secondary bg-opacity-10 text-secondary px-2 py-1 rounded-pill fw-semibold">
                      {data.amount.toLocaleString("en-PH", {
                        style: "currency",
                        currency: data?.currency_name || "PHP",
                      })}
                    </span>
                  </td>
                  <td className="py-3 text-muted">
                    <span className="text-danger fw-semibold">
                      {data.disbursementSumPayables.toLocaleString("en-PH", {
                        style: "currency",
                        currency: data?.currency_name || "PHP",
                      })}
                    </span>
                  </td>
                  <td className="py-3">
                    <span className="text-danger fw-semibold">
                      <div className="input-group mb-3">
                        <span className="input-group-text">₱</span>
                        <NumberInDecimals
                          className="form-control p-2"
                          required
                          placeholder="0.00"
                          value={data.allocated_payables}
                          decimals={3}
                          onChange={
                            (value) =>
                              handleAllocatedPayablesChange(data.id, value) // ← pass id + value
                          }
                          disabled={false}
                        />
                      </div>
                    </span>
                  </td>
                  <td className="py-3">
                    <span className="text-success fw-semibold">
                      <div className="input-group mb-3">
                        <span className="input-group-text">₱</span>
                        <NumberInDecimals
                          className="form-control p-2"
                          required
                          placeholder="0.00"
                          value={data.allocated_receivables} // ← bind value
                          decimals={3}
                          onChange={
                            (value) =>
                              handleAllocatedReceivablesChange(data.id, value) // ← pass id + value
                          }
                          disabled={false}
                        />
                      </div>
                      {/* <Form.Control className="w-100" /> */}
                    </span>
                  </td>
                  <td className="py-3">
                    <span
                      className="badge px-3 py-2 fw-semibold bank-budget-badge"
                      style={{
                        borderRadius: "8px",
                        fontSize: "0.85rem",
                      }}>
                      {calculateAvailableFunds(data).toLocaleString("en-PH", {
                        style: "currency",
                        currency: data?.currency_name || "PHP",
                      })}
                    </span>
                  </td>
                </tr>
              ))}

            {/* ))} */}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default NewBankBudgeting;
